/** Session flag so the profile page can show the hint after it mounts. */
export const TELEGRAM_PHONE_HINT_KEY = 'persianist:hintTelegramPhone';
export const TELEGRAM_PHONE_HINT_EVENT = 'app:hintTelegramPhone';

export function requestTelegramPhoneHint(): void {
  try {
    sessionStorage.setItem(TELEGRAM_PHONE_HINT_KEY, '1');
  } catch {
    /* private mode */
  }
  window.dispatchEvent(new CustomEvent(TELEGRAM_PHONE_HINT_EVENT));
}

export function consumeTelegramPhoneHint(): boolean {
  try {
    if (sessionStorage.getItem(TELEGRAM_PHONE_HINT_KEY) !== '1') return false;
    sessionStorage.removeItem(TELEGRAM_PHONE_HINT_KEY);
    return true;
  } catch {
    return false;
  }
}
